import React, { useRef } from "react";
import cx from "classnames";
import styles from "./styles.module.sass";
import Arrow from "./arrow.svg";
import MailchimpSubscribe from "react-mailchimp-subscribe";

const url =
  "https://lloydinn.us8.list-manage.com/subscribe/post?u=e2668211e4dcc74acd78fe090&id=d7eff1615d";

type CustomFormProps = {
  status?: "success" | "error" | "sending" | null;
  message?: string | null;
  onValidated?: (formData: { EMAIL: string }) => void;
  pClass?: string;
  className?: string;
};

const CustomForm: React.FC<CustomFormProps> = ({
  status = "",
  message = "",
  onValidated,
  pClass = "",
  className = "",
}) => {
  const emailRef = useRef<HTMLInputElement | null>(null);

  const emailRegex = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/;

  const submit = () => {
    const email = emailRef.current?.value;
    if (email && emailRegex.test(email)) {
      onValidated?.({
        EMAIL: email,
      });
    }
  };

  return (
    <div className={styles.base}>
      <p className={cx(pClass)}>Join our mailing list</p>
      <div className={cx(styles.inputBox, className && styles[className])}>
        <input ref={emailRef} type="email" placeholder="Your email" />
        <button className={styles.submit} onClick={submit}>
          <Arrow />
        </button>
      </div>
      {status === "success" && <p>Thank you for subscribing.</p>}
      {status === "error" && message?.includes("already") && (
        <p>Thank you for subscribing.</p>
      )}
      {status === "error" && message && !message.includes("already") && (
        <p>Sorry, an error occurred.</p>
      )}
    </div>
  );
};

type MailingListProps = {
  pClass?: string;
  className?: string;
};

const MailingList: React.FC<MailingListProps> = ({ pClass = "" }) => (
  <MailchimpSubscribe
    url={url}
    render={({ subscribe, status, message }) => (
      <CustomForm
        status={status}
        message={
          typeof message === "string" ? message : message?.message ?? null
        }
        onValidated={(formData) => subscribe(formData)}
        pClass={pClass}
      />
    )}
  />
);

export default MailingList;
